var render = function render(){var _vm=this,_c=_vm._self._c;return _c('listado-noticias',{attrs:{"endpoint":"/noticiasCaritas/todasNoticiasVisibles","title":"Cáritas parroquial","eyebrow":"Noticias","subtitle":"Actividades, campañas y proyectos de Cáritas en la parroquia.","caritas":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }